/*eslint-disable */
import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Dropdown, Modal, Radio, Divider, Header,Icon } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import { connect } from "react-redux";
import { AllRegex } from "../../utils/validation";
import UpdateAxios from '../axiosComponent/update';
import CreatAxios from '../axiosComponent/create';
import { DateData } from "../dynamicComponent/datepick";
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';
import moment from 'moment';
import {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from 'react-i18next';
import AddCity from '../dynamicComponent/addCity';
import { FIELD_IS_REQUIRED, INVALID_BANK_ACCOUNT_NO, INVALID_EMAIL, INVALID_FIELDS, INVALID_IFSC_CODE, INVALID_PAN_NUMBER, INVALID_PINCODE,INVALID_GST_NUMBER } from '../../utils/validationConstant';
import { options } from '../../views/Newdashboard/barChart';
import { values } from 'lodash';
import {LOCAL_STORAGE, DATE_FORMATS} from '../../utils/constant'
import UploadFile from '../dynamicComponent/Upload';
const VendorBranchEdit = ({ isSubmitting, handleSubmit, values, vendorId, setFieldValue, touched, errors, t, branchModal, CloseModal, editUserMode ,editData}) => {
    
    const [stateData, setStateData] = useState([]);
    useEffect(() => {
        let token = LOCAL_STORAGE.userToken
        let userId = LOCAL_STORAGE.userId
        let customerNo = LOCAL_STORAGE.customerNo

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
            
        }))
            .catch(error => console.log(error))
    },
   
     [])
    let options = []
    if (stateData.length > 0) {
        stateData.map((object, index) => {
            let temp = {}
            temp.text = object.state
            temp.value = object.stateId
            return options[index] = temp
        })
    }
  
    const chargeMechanismOption = [{
        id:1,
        text:"Forward Charging Mechanism",
        value:"FCM",
        key:1
    },{
        id:2,
        text:"Reverse Charging Mechanism",
        value:"RCM",
        key:2
    }]
    let max = new Date(`${currentYear}-12-31`)

    const getItReturnUrlImage = (imageKey) => {
        const userId = LOCAL_STORAGE.userId;
        const token = LOCAL_STORAGE.userToken;
        const customerNo = LOCAL_STORAGE.customerNo;
        return `${process.env.REACT_APP_MASTER_API}/transporterMaster/getDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
      }
    
      const getFile = (imageKey) => {
        const userId = LOCAL_STORAGE.userId;
        const token = LOCAL_STORAGE.userToken;
        const customerNo = LOCAL_STORAGE.customerNo;
        const url = `${process.env.REACT_APP_MASTER_API}/transporterMaster/getDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
        window.open(url, '_blank').focus();
      }

      const isImageFile = (key) => {
        let image_ext = ["jpeg", "jpg", "png"]
        let key_arr = key && key.split(".")
        let key_ext = key_arr && key_arr.length && key_arr[key_arr.length - 1]
        if(image_ext.includes(key_ext)) return true;
        else return false;
      }

    return (
        <Modal
            onClose={CloseModal}
            open={branchModal}
            size="large"
            className="p-overflow-initial"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{editData ? t('edit_title') : t('add')} {t("title")}</Modal.Header>
            <Modal.Content scrolling>
                <div className="ui form small">
                    <FormUi.Group inline={errors.billingPartyBranchName ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.branch")}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4" error={values.billingPartyBranchName ? false : true}>
                            <Fieldmik name="vendorBranchName" component={MyNormalInput} placeholder ={t("table_header.branch")} maxLength={50}/>
                        {touched.vendorBranchName && errors.vendorBranchName ? <small className="text-danger">{errors.vendorBranchName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="3" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.state")}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            
                                        <Dropdown
                                            search
                                            name="vendorBranchStateId"
                                            clearable
                                            style={{ width: "100%", fontWeight: "normal" }}
                                            selection
                                            value={values.vendorBranchStateId}
                                            options={options}
                                            placeholder ={t("table_header.state")}
                                            onChange={(name, data) => {
                                                setFieldValue("vendorBranchStateId", data.value);
                                            }}
                                        />
                             {touched.vendorBranchStateId && errors.vendorBranchStateId ? <small className="text-danger">{errors.vendorBranchStateId}</small> : ''}
                        </FormUi.Field>
                        
                    </FormUi.Group>
                    <FormUi.Group inline>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.city")}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                        <Fieldmik name="vendorBranchCity"
                         component={AddCity}
                         citynameValue={true}
                         placeholder ={ values.vendorBranchCity ?values.vendorBranchCity:t("table_header.city")}
                           />
                           
                            {touched.vendorBranchCity && errors.vendorBranchCity ? <small className="text-danger">{errors.vendorBranchCity}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="3" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.pincode")}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                            <Fieldmik name="vendorBranchPincode" component={MyNormalInput} placeholder={t("table_header.pincode")} />
                            {touched.vendorBranchPincode && errors.vendorBranchPincode ? <small className="text-danger">{errors.vendorBranchPincode}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.mobileNo ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.address")}</label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                            <Fieldmik name="vendorBranchAddress" type="text" component="textarea" placeholder={t("table_header.address")} maxLength={200}/>
                            {/* {touched.mobileNo && errors.mobileNo ? <small className="text-danger">{errors.mobileNo}</small> : ''} */}
                        </FormUi.Field>
                    </FormUi.Group>
                    <Divider horizontal>
                        <Header as='h4'>
                        {t("GST_Details")}
                        </Header>
                    </Divider>
                    <FormUi.Group>
                        <FormUi.Field width="2">
                            <label className="labelName mt-2">{t("Is_GST_Applicable")}</label>
                        </FormUi.Field>
                       
                       
                            <FormUi.Field width="1">
                                <Radio label="No" className='mt-2' name='isGSTApplicable' value='No'
                                    checked={values.isGSTApplicable === false} onChange={() => { setFieldValue("isGSTApplicable", !values.isGSTApplicable),
                                    setFieldValue("vendorBranchGST", "") ,
                                    setFieldValue("gstChargeMechanism", "") ,
                                    setFieldValue("validityStartDate", new Date(`${fromYear}-04-01 05:35:32`)) ,
                                    setFieldValue("validityEndDate", new Date(`${toYear}-03-31 05:35:32`)) 
                                    }} />
                            </FormUi.Field>
                        
                            <FormUi.Field width="1">
                                <Radio label="Yes" className='mt-2' name='isGSTApplicable' value='Yes'
                                    checked={values.isGSTApplicable === true} onChange={() => { setFieldValue("isGSTApplicable", !values.isGSTApplicable)}} />
                            </FormUi.Field>
                         <FormUi.Field width="1" />
                        <FormUi.Field width="4" />

                        {
                            values.isGSTApplicable ?
                                <>
                                    <FormUi.Field width="2">
                                        <label className="labelName">{t("table_header.gst_number")}{" "} <b className="w3-text-red"> *</b></label>
                                    </FormUi.Field>
                                    <FormUi.Field  width="4">
                                        <Fieldmik name="vendorBranchGST" component={MyNormalInput} placeholder={t("table_header.gst_number")} />
                                        {touched.vendorBranchGST && errors.vendorBranchGST ? <small className="text-danger">{errors.vendorBranchGST}</small> : ''}
                                    </FormUi.Field>
                                </> : null
                        }
                    </FormUi.Group>
                    {
                        values.isGSTApplicable ?
                            <>
                                <FormUi.Group>
                                   
                                    <>
                                    <FormUi.Field width={2}>
                                        <label>{t("table_header.validityStartDate")}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <DateData
                                            name="validityStartDate"
                                            autoComplete="off"
                                            dateFormat={DATE_FORMATS.ddMMyyyy}
                                            maxDate=  {new Date(values.validityEndDate).getFullYear()== currentYear ?values.validityEndDate:max}
                                            value = {values.validityStartDate}
                                     
                                        />
                                         {touched.gstValidityStartDate && errors.gstValidityStartDate ? <small className="text-danger">{errors.gstValidityStartDate}</small> : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width="3" />
                                    <FormUi.Field width={2}>
                                        <label>{t("table_header.validityEndDate")}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <DateData
                                            name="validityEndDate"
                                            autoComplete="off"
                                            dateFormat={DATE_FORMATS.ddMMyyyy}
                                            minDate={values.validityStartDate}
                                            value = {values.validityStartDate == null ?values.validityEndDate="":values.validityEndDate}
                                        />
                                         {touched.gstValidityStartDate && errors.gstValidityStartDate ? <small className="text-danger">{errors.gstValidityStartDate}</small> : ''}
                                    </FormUi.Field>
                                    </>
                                </FormUi.Group>

                                <FormUi.Group inline>
                                    <FormUi.Field width={2}>
                                        <label>{t("Charge_Mechanism.title")}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <Dropdown
                                            name="gstChargeMechanism"
                                            clearable
                                            style={{ width: "100%", fontWeight: "normal" }}
                                            selection
                                            placeholder={t("Charge_Mechanism.placeholder")}
                                            value={values.gstChargeMechanism}
                                            options={chargeMechanismOption}
                                            onChange={(name, data) => {
                                                setFieldValue("gstChargeMechanism", data.value);
                                            }}
                                        />
                                    </FormUi.Field>

                                    <FormUi.Field width={3} />
                                    <FormUi.Field width={2}>
                                        <label>{t("gst_certificate")}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <Fieldmik
                                            name="vendorBranchGSTCertPath"
                                            style={{ width: "23%" }}
                                            buttonName={
                                                values.vendorBranchGSTCertPath
                                                    ? "File Selected"
                                                    : "Choose File"
                                            }
                                            className="w3-button w3-round w3-small w3-border w3-hover-blue"
                                            typer={["pdf", "jpeg", "jpg", "png"]}
                                            values={values}
                                            component={UploadFile}
                                        />
                                        {
                                            values?.vendorBranchGSTCertPath && isImageFile(values?.vendorBranchGSTCertPath) ?
                                                <a href={getItReturnUrlImage(values?.vendorBranchGSTCertPath)} target="_blank">
                                                    <img src={getItReturnUrlImage(values?.vendorBranchGSTCertPath)} style={{ height: 60, width: 60 }} />
                                                </a>
                                                :
                                                <Button
                                                    onClick={() => getFile(values?.vendorBranchGSTCertPath)}
                                                    basic
                                                    size="mini"
                                                    type="button"
                                                    icon
                                                >
                                                    <Icon name="eye" color="blue" />
                                                </Button>
                                        }
                                    </FormUi.Field>
                                </FormUi.Group>
                                
                            </> : null
                    }
                    <Divider horizontal>
                        <Header as='h4'>
                        {t("Bank_Details")}
                        </Header>
                    </Divider>

                    <FormUi.Group inline={errors.mobileNo ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.bank_name")}{" "} <b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                            <Fieldmik name="vendorBranchBankName" type="text" component={MyNormalInput} placeholder={t("table_header.bank_name")} maxLength={50} />
                            {touched.vendorBranchBankName && errors.vendorBranchBankName ? <small className="text-danger">{errors.vendorBranchBankName}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="3" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.acc_holder")}{" "} <b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                            <Fieldmik name="vendorBranchBankAccountHolder" type="text" component={MyNormalInput} placeholder={t("table_header.acc_holder")} maxLength={50} />
                            {touched.vendorBranchBankAccountHolder && errors.vendorBranchBankAccountHolder ? <small className="text-danger">{errors.vendorBranchBankAccountHolder}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline={errors.mobileNo ? false : true}>
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.acc_number")}{" "} <b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                            <Fieldmik name="vendorBranchAccountNumber" type="text" component={MyNormalInput} placeholder={t("table_header.acc_number")} />
                            {touched.vendorBranchAccountNumber && errors.vendorBranchAccountNumber ? <small className="text-danger">{errors.vendorBranchAccountNumber}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="3" />
                        <FormUi.Field width="2">
                            <label className="labelName">{t("table_header.ifsc_code")}{" "} <b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field  width="4">
                            <Fieldmik name="vendorBranchBankIFSC" type="text" component={MyNormalInput} placeholder ={t("table_header.ifsc_code")}/>
                            {touched.vendorBranchBankIFSC && errors.vendorBranchBankIFSC ? <small className="text-danger">{errors.vendorBranchBankIFSC}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>

                    <FormUi.Group inline>
                    <FormUi.Field width={2}>
                                        <label>{t("cancelled_cheque")}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width={4}>
                                        <Fieldmik
                                            name="vendorBranchCancelledChq"
                                            style={{ width: "23%" }}
                                            buttonName={
                                                values.vendorBranchCancelledChq
                                                    ? "File Selected"
                                                    : "Choose File"
                                            }
                                            className="w3-button w3-round w3-small w3-border w3-hover-blue"
                                            typer={["pdf", "jpeg", "jpg", "png"]}
                                            values={values}
                                            component={UploadFile}
                                        />
                            {
                                values?.vendorBranchCancelledChq && isImageFile(values?.vendorBranchCancelledChq) ?
                                    <a href={getItReturnUrlImage(values?.vendorBranchCancelledChq)} target="_blank">
                                        <img src={getItReturnUrlImage(values?.vendorBranchCancelledChq)} style={{ height: 60, width: 60 }} />
                                    </a>
                                    :
                                    <Button
                                        onClick={() => getFile(values?.vendorBranchCancelledChq)}
                                        basic
                                        size="mini"
                                        type="button"
                                        icon
                                    >
                                        <Icon name="eye" color="blue" />
                                    </Button>
                            }
                                    </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={CloseModal}>
                    {t("cancel")}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {t("ok")}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

let currentYear = new Date().getFullYear()
let currentMonth = new Date().getMonth()
let fromYear =currentMonth <4?currentYear -1:currentYear
let toYear = fromYear+1
const FormikUserEdit = withFormik({
    
    enableReinitialize: true,
    mapPropsToValues: (props,
        vendorBranchName, vendorBranchCity, vendorBranchCityId, vendorBranchPincode,
        vendorBranchStateId, vendorBranchState, vendorBranchGST, vendorBranchPAN, vendorBranchAddress,
        vendorBranchBankName, vendorBranchBankAccountHolder, vendorBranchAccountNumber, vendorBranchBankIFSC) => {
        return {
            vendorBranchName: (props.editData != null ? props.editData.vendorBranchName : vendorBranchName) || '',
            //vendorBranchCityName: (props.editData != null ? props.editData.vendorBranchCity : vendorBranchCity) || '',
            vendorBranchCity: (props.editData != null ? props.editData.vendorBranchCityId : vendorBranchCity) || '',
            //vendorBranchCityId: (props.editData != null ? props.editData.vendorBranchCityId : vendorBranchCity) || '',
            vendorBranchPincode: (props.editData != null ? props.editData.vendorBranchPincode : vendorBranchPincode) || '',
            vendorBranchStateId: (props.editData != null ? props.editData.vendorBranchStateId : vendorBranchStateId) || '',
            vendorBranchState: (props.editData != null ? props.editData.vendorBranchState : vendorBranchState) || '',
            vendorBranchGST: props?.editData?.isGSTApplicable === 1?(props.editData != null ? props.editData.vendorBranchGST : vendorBranchGST) || '':"",
            isGSTApplicable:(props.editData?(props.editData.isGSTApplicable === 1 ? true :false ):true), 
            gstChargeMechanism :props?.editData?.isGSTApplicable === 1?  (props.editData != null && props.editData.gstChargeMechanism ) || "" :"",
          
            validityStartDate:props?.editData?.vendorBranchId ? (props?.editData?.validityStartDate ?  new Date(props.editData.validityStartDate) : "") : new Date(`${fromYear}-04-01 05:35:32`),
             validityEndDate: props?.editData?.vendorBranchId ? (props?.editData?.validatityEndDate ? new Date(props.editData.validatityEndDate) :  "") : new Date(`${toYear}-03-31 05:35:32`),
           
            // vendorBranchPAN: (props.editData != null ? props.editData.vendorBranchPAN : vendorBranchPAN) || '',
            vendorBranchAddress: (props.editData != null ? props.editData.vendorBranchAddress : vendorBranchAddress) || '',
            vendorBranchBankName: (props.editData != null ? props.editData.vendorBranchBankName : vendorBranchBankName) || '',
            vendorBranchBankAccountHolder: (props.editData != null ? props.editData.vendorBranchBankAccountHolder : vendorBranchBankAccountHolder) || '',
            vendorBranchAccountNumber: (props.editData != null ? props.editData.vendorBranchAccountNumber : vendorBranchAccountNumber) || '',
            vendorBranchBankIFSC: (props.editData != null ? props.editData.vendorBranchBankIFSC : vendorBranchBankIFSC) || '',
            // vendorId: (props.editUserMode ? '' : props.productName == 'vendor' ? (props.editParams ? props.editParams.u_id : '') : props.id) || '',
            vendorId: props.editUserMode || props.productName == 'vendor' ? props.id : '' || props.vendorId||'',
            vendorBranchGSTCertPath : props.editData?.vendorBranchGSTCertPath || "",
            vendorBranchCancelledChq : props.editData?.vendorBranchCancelledChq || ""
        }
    },
    validationSchema: yup.object({
        vendorBranchName: yup.string().required(FIELD_IS_REQUIRED).max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
        vendorBranchCity: yup.string().required(FIELD_IS_REQUIRED),
        vendorBranchPincode: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Pincode, INVALID_PINCODE),
        vendorBranchStateId: yup.number().required(FIELD_IS_REQUIRED), 
        vendorBranchGST: yup.string().when('isGSTApplicable', {
            is: (isGSTApplicable) => {
                return isGSTApplicable && isGSTApplicable == true ? true : false
            },
            then: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.GSTIN, INVALID_FIELDS.INVALID_GST_NUMBER),
            otherwise: yup.string().optional()
        }),
        vendorBranchBankName: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME).max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
        vendorBranchAccountNumber: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.BankAccNumber, INVALID_BANK_ACCOUNT_NO),
        vendorBranchBankIFSC: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.BankIFSCcode, INVALID_IFSC_CODE),
        vendorBranchBankAccountHolder: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME).max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
    }),
    async handleSubmit(values, { props }) {
        if (props.editData && props.vendorId) {

            if(values.gstChargeMechanism && values.gstChargeMechanism.trim()){
                if(!values.validityStartDate){
                  values.validityStartDate = new Date(`${fromYear}-04-01`)
                }
                if(!values.validityEndDate){
                  values.validityEndDate = new Date(`${toYear}-03-31`)
                }
              }

            await UpdateAxios({
                url: `vendorBranch`,
                payload: { ...values },
                uniqueId: props.editData.vendorBranchId,
            }).then((response) => {
                let alert = {
                    type: "success",
                    messageHeader: "Success",
                    messageBody: `Branch is updated.`,
                };
                
                props.successAlertDispatcher(alert);
                setTimeout(() => {
                    window.location.reload()
                  }, 1000);
            })
                .catch((err) => {
                    if (err.data.status === 204) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: `Unable to update branch `,
                        };
                        props.errorAlertDispatcher(alert);
                    }
                });
        } else {
            
            await CreatAxios({
                url: `vendorBranch/${props.vendorId}`,
                payload: { ...values },
            })
                .then((res) => {
                    console.log("tes");
                    console.log(res);
                    let alert = {
                        type: "success",
                        messageHeader: "Success",
                        messageBody: `Branch is created.`,
                    };
                    props.successAlertDispatcher(alert);
                    setTimeout(() => {
                        window.location.reload()
                      }, 1000);
                })
                .catch((err) => {
                    if (err) {
                        let alert = {
                            type: "error",
                            messageHeader: "Error",
                            messageBody: `Unable to create Branch`,
                        };
                        props.errorAlertDispatcher(alert);
                    }
                    
                    
                });
        }
    }

})(VendorBranchEdit)
export default connect(null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(translate('branch')(FormikUserEdit))
